import EN from './locales/en'
import DE from './locales/de'

const getLocale = () => {
    const lang = typeof window !== 'undefined' && window.localStorage.getItem('language_drei') || 'DE'
    return DE
}

export default getLocale